/**
 * Maps a Mender deployment status string to a human-readable display label.
 *
 * @param status - The raw Mender deployment status (e.g. "PENDING", "RUNNING", "COMPLETED", "ERROR")
 * @returns A formatted display string for the UI
 */
export function formatMenderStatus(status: string): string {
  switch (status?.toUpperCase()) {
    case 'PENDING':
      return 'Pending';
    case 'RUNNING':
      return 'Running';
    case 'COMPLETED':
      return 'Done';
    case 'ALREADY_INSTALLED':
      return 'Already Installed';
    case 'ERROR':
      return 'Error';
    case 'CANCELED':
      return 'Canceled';
    case 'SCHEDULED':
      return 'Scheduled';
    default:
      return status || '-';
  }
}
